import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey4 } from 'approot/shared/styles/colours.style';
import {
  LAYOUT_HEADER_HEIGHT,
  LayoutDrawerStyled,
} from 'approot/shared/layout/layout.styles';
import {
  ACTIVITY_BUILDER_DRAWER_WIDTH,
  ACTIVITY_BUILDER_DRAWER_BREAKPOINT,
  ACTIVITY_BUILDER_DRAWER_OVERLAY_Z_INDEX,
  ACTIVITY_BUILDER_SETTINGS_DRAWER_Z_INDEX,
} from '../activity-builder.constants';

type ActivityBuilderDraftDrawerProps = {
  $isActive: boolean;
};
export const ActivityBuilderDraftDrawer = styled.div<ActivityBuilderDraftDrawerProps>`
  position: fixed;
  right: 0;
  bottom: 0;
  flex-shrink: 0;
  top: 0;
  width: ${({ $isActive }) => ($isActive ? `100vw` : 0)};
  z-index: ${ACTIVITY_BUILDER_DRAWER_OVERLAY_Z_INDEX};

  ${LayoutDrawerStyled} {
    position: absolute;
  }

  @media (min-width: 320px) {
    width: ${({ $isActive }) =>
      rem($isActive ? ACTIVITY_BUILDER_DRAWER_WIDTH : 0)};
  }

  ${ACTIVITY_BUILDER_DRAWER_BREAKPOINT} {
    top: ${rem(LAYOUT_HEADER_HEIGHT)};
    z-index: ${ACTIVITY_BUILDER_SETTINGS_DRAWER_Z_INDEX};

    ${LayoutDrawerStyled} {
      border-left: 1px solid ${grey4};
      box-shadow: none;
      transition: none;

      width: ${({ $isActive }) =>
        rem($isActive ? ACTIVITY_BUILDER_DRAWER_WIDTH : 0)};
    }
  }
`;
